import { render, staticRenderFns } from "./EcommerceComp.vue?vue&type=template&id=ba568112&scoped=true"
import script from "./EcommerceComp.vue?vue&type=script&lang=js"
export * from "./EcommerceComp.vue?vue&type=script&lang=js"
import style0 from "./EcommerceComp.vue?vue&type=style&index=0&id=ba568112&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba568112",
  null
  
)

export default component.exports